"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importStar(require("react"));
var inversify_react_1 = require("inversify-react");
var OnboardingBannerPanel_1 = __importDefault(require("./OnboardingBannerPanel"));
var OnboardingBannerTelemetry_1 = __importDefault(require("./OnboardingBannerTelemetry"));
var mobx_react_1 = require("mobx-react");
var inversify_1 = require("inversify");
var DIProvider_1 = __importDefault(require("DIProvider/DIProvider"));
var OnboardingBanner = (0, mobx_react_1.observer)(function (_a) {
    var title = _a.title, description = _a.description, promptId = _a.promptId, actionCards = _a.actionCards, _b = _a.enabled, enabled = _b === void 0 ? true : _b;
    var serverTelemetry = (0, inversify_react_1.useInjection)("serverTelemetry");
    var promptHistory = (0, inversify_react_1.useInjection)("rootDataStore").userDataStore.useHistoryDataStore
        .inlinePromptsHistoryStore;
    var onboardingBannerTelemetry = (0, react_1.useMemo)(function () { return new OnboardingBannerTelemetry_1.default(serverTelemetry); }, [serverTelemetry]);
    var userHasDismissedPrompt = promptHistory.hasDismissed(promptId);
    var showBanner = enabled && !userHasDismissedPrompt;
    var handleDismissPrompt = function () {
        onboardingBannerTelemetry.bannerDismissed(promptId).catch(function (e) { });
        promptHistory.dismissedPrompt(promptId);
    };
    return (react_1.default.createElement(DIProvider_1.default, { container: function () {
            var container = new inversify_1.Container();
            container.bind(OnboardingBannerTelemetry_1.default).toConstantValue(onboardingBannerTelemetry);
            return container;
        } },
        react_1.default.createElement(OnboardingBannerPanel_1.default, { show: showBanner, title: title, description: description, onDismiss: handleDismissPrompt, actionCards: actionCards })));
});
exports.default = OnboardingBanner;
